module.exports = __webpack_public_path__ + "img/1561861928.97358cda.jpg";